import {
    useState, useCallback, useEffect, useContext
} from 'react';
import { withRouter } from 'react-router-dom';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { withApplicationPropertyContext } from 'tdic-components-platform-react';
import { TranslatorContext } from '@jutro/locale';
import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import metadata from './Quote.metadata.json5';
import styles from './Quote.module.scss';
import messages from './Quote.messages';

function Quote({ loggedUserContact }) {
    const translator = useContext(TranslatorContext);
    const [selectedLob, setSelectedLob] = useState();
    const [requestParams, updateRequestParams] = useState({});
    const { quoteLink } = appConfig.tdic;

    const getPrimaryPhoneNumber = useCallback((accountContact) => {
        const primaryPhoneType = _.get(accountContact, 'primaryPhoneType');
        if (primaryPhoneType === 'work') {
            return _.get(accountContact, 'workNumber', '');
        } if (primaryPhoneType === 'home') {
            return _.get(accountContact, 'homeNumber', '');
        }
        return _.get(accountContact, 'cellNumber', '');
    }, []);

    useEffect(() => {
        const params = {
            firstName: _.get(loggedUserContact, 'accountContact.firstName', ''),
            lastName: _.get(loggedUserContact, 'accountContact.lastName', ''),
            addressLine1: _.get(loggedUserContact, 'accountContact.primaryAddress.addressLine1', ''),
            addressLine2: _.get(loggedUserContact, 'accountContact.additionalAddresses[0].addressLine1', ''),
            city: _.get(loggedUserContact, 'accountContact.primaryAddress.city', ''),
            state: _.toUpper(_.get(loggedUserContact, 'accountContact.primaryAddress.state', '')),
            zipCode: _.get(loggedUserContact, 'accountContact.primaryAddress.postalCode', ''),
            primaryPhone: getPrimaryPhoneNumber(loggedUserContact.accountContact),
            primaryEmail: _.get(loggedUserContact, 'accountContact.emailAddress1', ''),
            adaNumber: _.get(loggedUserContact, 'accountContact.adaNumber_Ext', '')
        };
        updateRequestParams(params);
        // Execute once
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onQuoteButtonClick = useCallback(
        () => {
            if (selectedLob) {
                const queryString = _.isEmpty(requestParams) ? '' : Object.keys(requestParams).map((key) => `${key}=${encodeURIComponent(requestParams[key])}`).join('&');
                const environment = _.get(quoteLink, _.toLower(process.env.NODE_ENV), _.get(quoteLink, 'development'));
                const redirectURL = _.isEmpty(queryString) ? environment[selectedLob] : `${environment[selectedLob]}?${queryString}`;
                window.open(redirectURL);
            }
        },
        [quoteLink, requestParams, selectedLob]
    );

    const overrideProps = {
        quoteButton: {
            disabled: !selectedLob
        },
        quoteSelection: {
            value: selectedLob,
            onValueChange: setSelectedLob
        },
        pageTitle: {
            value: translator(messages.getAQuote)
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onQuoteButtonClick
        }
    };

    return renderContentFromMetadata(metadata.pageContent, overrideProps, resolvers);
}

export default withApplicationPropertyContext(withRouter(Quote));
